var _polygon, _polygon2, _path, _path2, _path3, _path4, _rect, _path5, _rect2, _polygon3, _path6, _polygon4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 265.85,
    height: 92.82,
    viewBox: "0 0 265.85 92.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "59.07 41.23 27.64 2.23 0 2.23 0 90.58 29.28 90.58 29.28 49.82 62.1 90.58 88.35 90.58 88.35 2.23 59.07 2.23 59.07 41.23",
    fill: "red",
    strokeWidth: 0
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "184.31 2.23 184.31 27.22 210.31 27.22 210.31 90.58 239.85 90.58 239.85 27.22 265.85 27.22 265.85 2.23 184.31 2.23",
    fill: "red",
    strokeWidth: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M261.35,83.16c.26-.35.39-.8.39-1.35v-.04c0-.67-.2-1.21-.6-1.61-.24-.24-.56-.44-.95-.58-.39-.14-.86-.21-1.42-.21h-3.27v7.03h1.95v-2.14h.86l1.42,2.14h2.25l-1.68-2.45c.44-.18.79-.45,1.05-.8ZM259.79,81.94c0,.26-.09.46-.27.6-.18.15-.44.22-.79.22h-1.28v-1.7h1.26c.33,0,.59.07.79.21.19.14.29.35.29.63v.04Z",
    fill: "red",
    strokeWidth: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M263.7,77.81c-.67-.68-1.45-1.22-2.36-1.62-.91-.4-1.88-.6-2.92-.6s-2.02.2-2.93.6c-.91.4-1.71.94-2.38,1.63-.67.69-1.2,1.48-1.58,2.39-.38.91-.58,1.87-.58,2.88v.04c0,1.02.19,1.97.58,2.87.38.9.91,1.69,1.57,2.37.67.68,1.45,1.22,2.36,1.62.91.4,1.88.6,2.92.6s2.02-.2,2.93-.6c.91-.4,1.71-.94,2.38-1.63.67-.69,1.2-1.48,1.58-2.39.38-.91.58-1.87.58-2.88v-.04c0-1.02-.19-1.97-.58-2.87-.38-.9-.91-1.69-1.57-2.37ZM264.24,83.09c0,.8-.15,1.57-.45,2.28-.3.72-.71,1.35-1.23,1.89-.52.54-1.14.97-1.85,1.28-.71.31-1.49.47-2.33.47s-1.6-.16-2.31-.47c-.71-.31-1.33-.73-1.85-1.26-.52-.53-.93-1.15-1.22-1.87-.29-.72-.44-1.48-.44-2.28v-.04c0-.8.15-1.56.45-2.28.3-.72.71-1.35,1.23-1.89.52-.54,1.14-.97,1.85-1.28.71-.31,1.49-.47,2.33-.47s1.6.16,2.31.47c.71.31,1.33.73,1.85,1.26.52.53.93,1.15,1.22,1.87.3.72.45,1.48.45,2.28v.04Z",
    fill: "red",
    strokeWidth: 0
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M106.9,13.75c-18.42,18.42-18.2,47.12-.08,65.24l.18.18c18.12,18.12,46.47,18.33,64.89-.09,18.42-18.42,18.2-47.12.09-65.24l-.18-.18c-18.12-18.12-46.47-18.33-64.89.09ZM164.59,14.32l6.88,6.88c2.96,2.96,2.96,7.77,0,10.73l-46.56,46.56c-2.96,2.96-7.77,2.96-10.73,0l-6.88-6.88c-2.96-2.96-2.96-7.77,0-10.73l46.56-46.56c2.96-2.96,7.77-2.96,10.73,0Z",
    fill: "red",
    strokeWidth: 0
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M118.48,74.83l4.05-4.05c1.34-1.34,2.01-2.46,2.06-4.01.03-.88-.16-2.36-1.7-3.9-.94-.94-2.23-1.67-3.58-1.7-1.74-.02-3,.86-4.21,2.07l-4.1,4.1,7.48,7.48ZM114.19,66.81l2.16-2.16c.65-.65,1.22-1.11,2.02-1.18,1.25-.11,2.34.96,2.58,1.2,2.02,2.02,1.58,3.47.26,4.78l-2.19,2.19-4.83-4.83Z",
    fill: "red",
    strokeWidth: 0
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 124.08,
    y: 55.13,
    width: 2.65,
    height: 10.58,
    transform: "translate(-5.99 106.37) rotate(-45)",
    fill: "red",
    strokeWidth: 0
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M132.46,59.62c.97-.15,2.28-.6,3.87-2.19,1.97-1.97,2.01-3.75,2.01-4.18l.86.86,1.43-1.43-4.01-4.01-4.02,4.02,1.35,1.35,2.45-2.45c.07.18.22.46.25.95.07,1.2-.63,2.45-1.44,3.26-.47.47-2.98,2.7-5.45.23-1.72-1.72-1.36-3.84.18-5.37.92-.92,2.02-1.43,3.3-1.24l1.78-2.35c-2.35-.81-4.79.53-6.39,2.13-1.35,1.35-2.49,3-2.44,5.11.02.68.27,2.28,1.62,3.64,1.96,1.96,3.77,1.8,4.64,1.67Z",
    fill: "red",
    strokeWidth: 0
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 138.43,
    y: 40.78,
    width: 2.65,
    height: 10.58,
    transform: "translate(8.36 112.32) rotate(-45)",
    fill: "red",
    strokeWidth: 0
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "148.17 45.14 150.05 43.25 143.94 37.14 146.71 34.37 145.34 33.01 137.91 40.44 139.28 41.8 142.05 39.03 148.17 45.14",
    fill: "red",
    strokeWidth: 0
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M153.73,39.58l-.77-2.05,3.84-3.84,2.05.77,2.1-2.1-11.1-3.87-2.02,2.02,3.87,11.1,2.05-2.05ZM150.64,31.35l4.23,1.62-2.63,2.63-1.6-4.25Z",
    fill: "red",
    strokeWidth: 0
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "166.43 24.12 162.28 28.28 156.17 22.17 154.29 24.05 161.78 31.53 167.81 25.5 166.43 24.12",
    fill: "red",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.cf21bd0261362f36cf2130e1724bb692.svg";
export { ForwardRef as ReactComponent };